module.exports = __webpack_public_path__ + "static/float-8017ad964d30f589eeed3f513751cda8.png";